import Vue from 'vue'
import { getStorage, setStorage, removeStorage } from '@/utils/storage'
Vue.prototype.$getStorage = getStorage
Vue.prototype.$setStorage = setStorage
Vue.prototype.$removeStorage = removeStorage



// WEBPACK FOOTER //
// ./src/plugins/storage.js